import { Company } from './company';

export class Supplier extends Company {
  company: Company = null;
  type = 'supplier';

  constructor() {
    super();
  }
}
